import { reset as resetAftermarket } from './store.aftermarket';
import { reset as resetAnswers } from './store.answers';
import { reset as resetAutocheck } from './store.autocheck';
import { reset as resetCompareVehicle } from './store.compare-vehicle';
import { reset as resetCustomer } from './store.customer';
import { partialReset as partialResetDealer } from './store.dealer';
import { reset as resetExterior } from './store.exterior';
import { reset as resetHistory } from './store.history';
import { reset as resetInterior } from './store.interior';
import { reset as resetKbycOffer } from './store.kelley-buys-your-car-offer';
import { reset as resetMechanical } from './store.mechanical';
import { partialReset as partialResetOffer } from './store.offer';
import { reset as resetOfferVehicle } from './store.offer-vehicle';
import { reset as resetQuestionVehicle } from './store.question-vehicle';
import { reset as resetReplacement } from './store.replacement';
import { reset as resetSupplement } from './store.supplement';
import { reset as resetTracking } from './store.tracking';
import { reset as resetAscTracking } from './store.tracking-asc';
import { reset as resetValidation } from './store.validation';
import { reset as resetVehicleConfig } from './store.vehicle-config';

export const resetAll = () => {
  resetAftermarket();
  resetAnswers();
  resetAutocheck();
  resetCustomer();
  partialResetDealer(['isDealerCobrandingDrEnabled']);
  resetExterior();
  resetHistory();
  resetInterior();
  resetMechanical();
  partialResetOffer(['inProgressBtnText']);
  resetKbycOffer();
  resetReplacement();
  resetSupplement();
  resetTracking();
  resetValidation();
  resetOfferVehicle();
  resetQuestionVehicle();
  resetCompareVehicle();
  resetVehicleConfig();
  resetAscTracking();
  // do not reset store.page-params: it is set once on page load and is not updated from offer
};
